import Popper, { type PopperProps } from "@mui/material/Popper";
import { forwardRef, type ReactNode } from "react";
import "./dynamic-nodes.css";

const modifiers: NonNullable<PopperProps["modifiers"]> = [
  {
    name: "offset",
    options: { offset: [0, 6] },
  },
  {
    name: "flip",
    options: {
      boundary: "viewport",
      fallbackPlacements: ["top-start"],
      padding: 8,
    },
  },
  {
    name: "preventOverflow",
    options: {
      altAxis: true,
      boundary: "viewport",
      padding: 8,
    },
  },
];

const popperOptions: NonNullable<PopperProps["popperOptions"]> = {
  strategy: "fixed",
};

interface DynamicNodePopoverProps {
  anchorEl: NonNullable<PopperProps["anchorEl"]>;
  children: ReactNode;
  className: string;
}

export const DynamicNodePopover = forwardRef<
  HTMLDivElement,
  DynamicNodePopoverProps
>(({ anchorEl, children, className }, ref) => (
  <Popper
    ref={ref}
    anchorEl={anchorEl}
    className={`${className} tiptap-dynamic-node-popover`}
    modifiers={modifiers}
    open
    placement="bottom-start"
    popperOptions={popperOptions}
  >
    {children}
  </Popper>
));

DynamicNodePopover.displayName = "DynamicNodePopover";
